import { useSuspenseQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/cn';
import { tenantQuery } from '@/queries';

/**
 * The mark of the system itself, ESSE, on the staff screens and the sign-in page.
 *
 * Guy named the system on 30 October 2026: ESSE comes from OBSESSED, the core
 * of it, the main engine. Christian supplied the logo the same day. The shop's
 * own mark (`Wordmark`) stays for anything a customer sees.
 *
 * Both come from settings (`brand.system_name`, `brand.system_logo_url`), so the
 * owner changes them on Settings. With no logo, the name is drawn as type, so a
 * tenant without artwork still has a header.
 *
 * The artwork is black on a clear background. `.logo-mark` turns it white on the
 * dark theme, in globals.css.
 */
export function SystemMark({ className, href = '/admin' }: { className?: string; href?: string }) {
  const tenant = useSuspenseQuery(tenantQuery).data;
  return (
    <Link to={href} className={cn('inline-flex items-center', className)}>
      {tenant.system_logo_url ? (
        <img src={tenant.system_logo_url} alt={tenant.system_name} className="logo-mark h-6 w-auto sm:h-7" />
      ) : (
        <span className="font-[family-name:var(--font-serif)] text-[20px] font-bold tracking-[0.02em]">
          {tenant.system_name}
        </span>
      )}
      <span className="sr-only">home</span>
    </Link>
  );
}
